import { propsFactory } from '@components/utils';

import type { PropType } from 'vue';

export type TAlign = typeof allowedAlign[number];

export const allowedAlign = ['start', 'center', 'end'];

export interface IAlignProps {
  align: TAlign;
}

export const makeAlignProps = propsFactory(
  {
    /**
     * Выравнивание
     */
    align: {
      type: String as PropType<TAlign>,
      default: 'start'
    }
  },
  'align'
);
